const openUrl = url => {
  if (!url) return;

  if (!url.includes('://')) url = 'https://' + url;

  const agent = navigator.userAgent.toUpperCase();

  const safari =
    agent.indexOf('SAFARI') >= 0 && agent.indexOf('CHROME') < 0 ? true : false;

  const mobile = navigator.userAgent.includes('Mobile') ? true : false;

  if (/Mobi/i.test(window.navigator.userAgent) || safari || mobile) {
    location.href = url;
  } else {
    window.open(url, '_blank');
  }
};

export default openUrl;
